import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { imagesResponse } from "../../api/responses";

export const apartmentsState = (state: RootState) => state.apartments;

export const selectAllApartments = createSelector(
  apartmentsState,
  (state) => state.apartmentsList
);

export const selectCurrentApartment = createSelector(
  apartmentsState,
  (state) => state.currentApartment
);

export const selectAllContent = createSelector(
  apartmentsState,
  (state) => state?.photos || imagesResponse
);

export const selectVideoContent = createSelector(
  apartmentsState,
  (state) => state.videoLink
);

export const selectApartmentsLink = createSelector(
  selectAllApartments,
  (apartments) => {
    return apartments?.map((apartment) => ({
      nameIT: apartment.apartmenttypeit,
      nameEN: apartment.apartmenttypeen,
      picture: apartment.photos[0].url,
      navLink: `${apartment.apartmenttypeit}`,
    }));
  }
);

export const makeSelectApartment = (name: string) => {
  return createSelector(selectAllApartments, (apartments) => {
    const apartment = apartments?.find(
      (ap) => ap.apartmenttypeit.toLowerCase() === name
    );
    return apartment;
  });
};

export const selectReviews = createSelector(
  apartmentsState,
  (state) => state.reviews
);

export const selectIsLoading = createSelector(
  apartmentsState,
  (state) => state.isLoading
);
export const selectError = createSelector(
  apartmentsState,
  (state) => state.errorAPI
);
export const selectHasInitialized = createSelector(
  apartmentsState,
  (state) => state.hasInitialized
);

export const selectLanguage = createSelector(
  apartmentsState,
  (st) => st.language
);
